import React from "react";
import Parse from "parse";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Menu,
  MenuItem,
  IconButton,
  Typography,
} from "@mui/material";
import FadeIn from "react-fade-in";
import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useRef, useEffect, useState } from "react";
import MenuIcon from "@material-ui/icons/Menu";
import { Loading } from "../../../../components";
import { useQuery, gql } from "@apollo/client";
import { useAuth } from "../../../../hooks/useAuth";

const useStyles = makeStyles((theme: any) => ({
  card: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    height: "375px",
    boxShadow: theme.shadows[4],
    borderRadius: 15,
    outlineColor: "#2c2c33",
    outlineStyle: "solid",
    outlineWidth: 1,
  },
  grid: {
    flexGrow: 1,
  },
  popover: {
    backgroundColor: theme.palette.secondary.dark,
    borderRadius: 11,
    outlineColor: "#2c2c33",
    outlineStyle: "solid",
    outlineWidth: 1,
  },
  title: {
    fontSize: 18,
    fontWeight: 500
  },
  titleFont: {
    fontWeight: 500
  },
}));

export default function StudentStats() {
  const theme = useTheme();
  const classes = useStyles(theme);

  const auth = useAuth();
  const [data, setData] = useState<any>(undefined);
  const [loading, setLoading] = useState(true);
  const [sub, setSub] = useState("Interested High School Students");

  useEffect(() => {
    if (auth.collegeId) {
      async function fetchData() {
        setLoading(true);

        await Parse.Cloud.run("dashboardInterestedStudentsStats", { collegeId: auth.collegeId }).then((response) => {
          setLoading(false);
          setData(response);
        });
      }
      fetchData();
    }
  }, [auth.collegeId]);

  return (
    <FadeIn delay={100}>
      <Card style={{
        backgroundColor: theme.palette.primary.dark,
        padding: theme.spacing(2),
        height: 350,
        boxShadow: theme.shadows[4],
        borderRadius: 25,
        outlineColor: "#2c2c33",
        outlineStyle: "solid",
        outlineWidth: 1,
      }}>
        <CardHeader
          title="Student Stats"
          subheader={sub}
          titleTypographyProps={{ fontWeight: 600 }}
        />
        <CardContent>
          {loading ? (
            <Loading />
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Typography variant="h5" color="secondary" align="left">
                  {data?.avgSAT?.toFixed(
                    0
                  ) ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title} align="right" color="textSecondary">
                  Avg SAT
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h5" color="secondary" align="left">
                  {data?.avgACT?.toFixed(
                    1
                  ) ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title} align="right" color="textSecondary">
                  Avg ACT
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h5" color="secondary" align="left">
                  {data?.avgGPA?.toFixed(
                    1
                  ) ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title} align="right" color="textSecondary">
                  Avg GPA
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h5" color="secondary" align="left">
                  {(data?.avgRank * 100) > 0 ? (data?.avgRank * 100).toFixed(1) + "%" : "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title} align="right" color="textSecondary">
                  Avg Rank
                </Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </FadeIn>
  );
}
